import { render, staticRenderFns } from "./NeoPeople.vue?vue&type=template&id=77dc594d&scoped=true&"
import script from "./NeoPeople.vue?vue&type=script&lang=js&"
export * from "./NeoPeople.vue?vue&type=script&lang=js&"
import style0 from "./NeoPeople.vue?vue&type=style&index=0&id=77dc594d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dc594d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
